import { Currency, CurrencyAmount } from '@kodiak-finance/sdk-core'
import { SupportedChainId } from 'config/chains'
import JSBI from 'jsbi'

// Native currency kept back for gas. 0.1 suits BERA but would lock ~$250 of ETH on Robinhood,
// where even a 3M-gas LP mint costs well under 0.0001 ETH; 0.0005 leaves headroom for gas price
// spikes and the L1 data fee.
const NATIVE_GAS_RESERVE: Record<SupportedChainId, JSBI> = {
  [SupportedChainId.BERA]: JSBI.BigInt('100000000000000000'),
  [SupportedChainId.BEPOLIA]: JSBI.BigInt('100000000000000000'),
  [SupportedChainId.ROBINHOOD]: JSBI.BigInt('500000000000000'),
}

/**
 * Given some token amount, return the max that can be spent of it
 * @param currencyAmount to return max of
 */
export function maxAmountSpend(currencyAmount?: CurrencyAmount<Currency>): CurrencyAmount<Currency> | undefined {
  if (!currencyAmount) return undefined
  if (currencyAmount.currency.isNative) {
    const reserve = NATIVE_GAS_RESERVE[currencyAmount.currency.chainId as SupportedChainId]
    if (!reserve) return undefined
    if (JSBI.greaterThan(currencyAmount.quotient, reserve)) {
      return CurrencyAmount.fromRawAmount(currencyAmount.currency, JSBI.subtract(currencyAmount.quotient, reserve))
    } else {
      return CurrencyAmount.fromRawAmount(currencyAmount.currency, JSBI.BigInt(0))
    }
  }
  return currencyAmount
}
